import {
	SET_CUSTOMER_DATA_FILLED_FROM_LOGIN,
	SetCustomerDataFilledFromLoginActionType,
} from 'store/actions/customerDataFilledFromLogin';

const customerDataFilledFromLogin = (
	state = false,
	action: SetCustomerDataFilledFromLoginActionType
): boolean => {
	if (action.type === SET_CUSTOMER_DATA_FILLED_FROM_LOGIN) {
		return action.payload;
	}
	return state;
};

export default customerDataFilledFromLogin;
